export const TestRecallData = {
    vehicle: {
        vin: "1212121",
        year: 2007,
        make: "Mercedes-Benz",
        model: "M-Class",
        dataRefreshDate: null,
        numberOfRecalls: 1,
        recallsAvailable: true,
        dealerCode: "RecallRabbit-tst",
        oemCode: "MB",
        oemDescription: "Mercedes-Benz",
        errorReasonCode: null,
    },
    recalls: [
        {
            oemRecallNumber: "2022050014",
            status: "Open",
            recallState: "Available",
            recallType: "Other",
            isExcluded: false,
            isApproved: true,
            nhtsaNumber: "22V315",
            severityCode: "Unknown",
            recallIssueDate: "0001-01-01T00:00:00.000-05:51",
            recallRefreshDate: "2022-09-01T14:31:02.540-05:00",
            recallTitle:
                'Mercedes-Benz AG ("MBAG"), the manufacturer of Mercedes-Benz vehicles, has determined that on certain Model Year ("MY") 2006-2012 ML, GL (164 platform) and R-Class (251 platform) vehicles, the function of the brake booster might be affected due to advanced corrosion in the joint area of its housing.',
            recallDescription:
                'Mercedes-Benz AG ("MBAG"), the manufacturer of Mercedes-Benz vehicles, has determined that on certain Model Year ("MY") 2006-2012 ML, GL (164 platform) and R-Class (251 platform) vehicles, the function of the brake booster might be affected due to advanced corrosion in the joint area of its housing.',
            riskDescription: "",
            remedyDescription: "",
            notAvailableReason: null,
            oemCode: "MB",
            oemDescription: "Mercedes-Benz",
            recallPartsCost: 0,
            recallLaborHours: 0,
        },
    ],
    license_plate_data: {
        vin: "1212121",
        year: "2007",
        make: "Mercedes-Benz",
        model: "M-Class",
        trim: "AMG ML 63",
        name: "2007 Mercedes-Benz M-Class",
        engine: "6.3L V8 DOHC 32V",
        style: "SUV",
        transmission: "Automatic",
        driveType: "4WD",
        fuel: "Gasoline",
        color: {
            name: "Black",
            abbreviation: "BLK",
        },
        image: {
            imageFound: false,
            url: null,
        },
    },
};